import AntdPagination from 'antd/lib/pagination';
import AntdEsPagination from 'antd/es/pagination';
import AntdV5Pagination from 'antd-v5/lib/pagination';
import AntdV5EsPagination from 'antd-v5/es/pagination';

export const defaultShowTotal = (total) => `共 ${total} 条`;

export function withDefaultShowTotal(pagination) {
  if (pagination === false) {
    return false;
  }

  return {
    showTotal: defaultShowTotal,
    ...pagination,
  };
}

function setDefaultShowTotal(Pagination) {
  if (!Pagination) {
    return;
  }

  Pagination.defaultProps = {
    ...Pagination.defaultProps,
    showTotal: Pagination.defaultProps?.showTotal || defaultShowTotal,
  };
}

export function setupPaginationShowTotal() {
  setDefaultShowTotal(AntdPagination);
  setDefaultShowTotal(AntdEsPagination);
  setDefaultShowTotal(AntdV5Pagination);
  setDefaultShowTotal(AntdV5EsPagination);
}
